import React from "react";
import { useForm } from "react-hook-form";
import { post } from "../../services/api";
import { toast } from "react-toastify";

function ReAdmissionModal({ onClose, studentId, refreshOnSubmitSuccess }) {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      studentId: studentId,
      reAdmissionDate: new Date().toISOString().split("T")[0],
      remarks: "",
      createdBy: userId,
    },
  });

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      studentId: parseInt(studentId, 10),
      reAdmissionDate: new Date(data.reAdmissionDate).toISOString(),
      createdBy: userId,
    };

    try {
      const response = await post("Student/re-admit", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success(response.message || "Student re-admitted successfully!");
        onClose();
        refreshOnSubmitSuccess();
      } else {
        toast.error(response.message || "Failed to re-admit student.");
      }
    } catch (error) {
      console.error("Error re-admitting student:", error);
      toast.error("An error occurred while re-admitting the student.");
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Student Re-Admission</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form
                className="row g-3 new-form-style"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="col-md-12">
                  <label className="form-label form-label-new">
                    Re-Admission Date<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    type="date"
                    {...register("reAdmissionDate", {
                      required: "This field is required.",
                    })}
                    className="form-control"
                  />
                  {errors.reAdmissionDate && (
                    <small className="text-danger">
                      {errors.reAdmissionDate.message}
                    </small>
                  )}
                </div>
                <div className="col-md-12">
                  <label className="form-label form-label-new">
                    Remarks<span className="text-danger fs-9">*</span>
                  </label>
                  <textarea
                    {...register("remarks", {
                      required: "This field is required.",
                    })}
                    className="form-control"
                    rows="3"
                  ></textarea>
                  {errors.remarks && (
                    <small className="text-danger">
                      {errors.remarks.message}
                    </small>
                  )}
                </div>
                <div className="d-flex gap-2 justify-content-end">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-custom-size me-1"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    <span role="status">Save</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default ReAdmissionModal;
